let language = {
    RETURN_DETAIL_SUBMIT_EXPRESS: "Submit Express",
    RETURN_DETAIL_TEACKING_NO: "Tracking No:",
    RETURN_DETAIL_EXPRESS: "Express:",

};

export { language }
